/* @flow */

import { combineReducers } from 'redux';
import { FETCH_PAGES_SUCCESS } from 'catalog/actions/pages';
import {
  CHANGE_EDITION_PLATFORM,
  CHANGE_CATALOG_PLATFORM,
} from 'catalog/actions/platforms';

const items = (state = [], action) => {
  switch (action.type) {
    case FETCH_PAGES_SUCCESS:
      return action.platforms;
    default:
      return state;
  }
};

const edit = (state = null, action) => {
  switch (action.type) {
    case CHANGE_EDITION_PLATFORM:
      return action.platform;
    default:
      return state;
  }
};

const catalog = (state = null, action) => {
  switch (action.type) {
    case CHANGE_CATALOG_PLATFORM:
      return action.platform;
    default:
      return state;
  }
};

export default combineReducers({
  items,
  edit,
  catalog,
});

export const getPlatforms = state => state.platforms.items;

export const getDefaultPlatform = state => {
  const platforms = getPlatforms(state);
  return platforms.find(p => p.isDefault);
};

export const getEditionPlatform = state => {
  const edit = state.platforms.edit;

  return edit || getDefaultPlatform(state);
};

export const getCatalogPlatform = state => {
  const catalog = state.platforms.catalog;

  return catalog || getDefaultPlatform(state);
};



// WEBPACK FOOTER //
// ./src/modules/catalog/reducers/platforms.js